"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeConnection = void 0;
var socket_io_client_1 = require("socket.io-client");
var Logger_1 = __importDefault(require("../Core/Logger"));
var RealtimeConnection = /** @class */ (function () {
    function RealtimeConnection(endpoint, notifiable) {
        this.endpoint = endpoint;
        this.notifiable = notifiable;
    }
    RealtimeConnection.connect = function (endpoint, notifiable) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new RealtimeConnection(endpoint, notifiable).initInternal()];
            });
        });
    };
    RealtimeConnection.prototype.disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this_1._socket.on('disconnect', function () {
                            _this_1._socket.off('disconnect');
                            _this_1._socket.close();
                            resolve();
                        });
                        _this_1._socket.disconnect();
                        var id = setTimeout(function () {
                            clearTimeout(id);
                            _this_1._socket.close();
                            resolve();
                        }, 5000);
                    })];
            });
        });
    };
    RealtimeConnection.prototype.initInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initSocket()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    //'this' passed intentionally to support better testability
    RealtimeConnection.prototype.handleOnConnectAsync = function (_this) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            _this.handleOnConnect(resolve);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RealtimeConnection.prototype.handleOnConnect = function (resolve) {
        var _this_1 = this;
        if (resolve === void 0) { resolve = null; }
        this._socket.on('connect', function () { return __awaiter(_this_1, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger_1.default.debug('connected to server');
                        if (!this.notifiable) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.notifiable.onConnect(this)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (resolve) {
                            resolve();
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    RealtimeConnection.prototype.handleOnReconnect = function () {
        var _this_1 = this;
        this._socket.on('reconnect', function () { return __awaiter(_this_1, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger_1.default.debug('reconnected to server');
                        if (!this.notifiable) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.notifiable.onReconnect(this)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    RealtimeConnection.prototype.handleOnDisconnect = function () {
        var _this_1 = this;
        this._socket.on('disconnect', function () { return __awaiter(_this_1, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger_1.default.debug('disconnected from server');
                        if (!this.notifiable) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.notifiable.onDisconnect(this)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    RealtimeConnection.prototype.initSocket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options;
            return __generator(this, function (_a) {
                options = {
                    forceNew: false,
                    multiplex: false,
                    reconnection: true,
                    autoConnect: true,
                    transports: ['websocket'],
                    transportOptions: {
                        websocket: {
                            port: this.endpoint.port,
                            secure: this.endpoint.protocol === "https:" /* EndpointProtocol.Https */ ||
                                this.endpoint.protocol === "wss:" /* EndpointProtocol.SecureWebSocket */
                        }
                    }
                };
                this._socket = (0, socket_io_client_1.io)(this.endpoint.encode(), options);
                this.handleOnConnect();
                this.handleOnReconnect();
                this.handleOnDisconnect();
                return [2 /*return*/, this];
            });
        });
    };
    Object.defineProperty(RealtimeConnection.prototype, "socket", {
        get: function () {
            return this._socket;
        },
        enumerable: false,
        configurable: true
    });
    return RealtimeConnection;
}());
exports.RealtimeConnection = RealtimeConnection;
//# sourceMappingURL=RealtimeConnection.js.map